import { IconWrapper } from '../runtime';
export default IconWrapper('exit-full-screen', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M9.75 1.74976H12.75C13.5784 1.74976 14.25 2.42133 14.25 3.24976V6.24976M6.25 14.2498H3.25C2.42157 14.2498 1.75 13.5782 1.75 12.7498V9.74976M1.75 6.24976L4.75 6.24976C5.15936 6.24976 5.53042 6.08577 5.80107 5.81992M6.25 1.74976L6.25 4.74976C6.25 5.16882 6.07815 5.54775 5.80107 5.81992M5.80107 5.81992L2 1.99976M9.75 14.2498V11.2498C9.75 10.8355 9.91789 10.4605 10.1893 10.1891M14.25 9.74976L11.25 9.74976C10.8358 9.74976 10.4608 9.91765 10.1893 10.1891M10.1893 10.1891L14 13.9998",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});